import React from "react";
import { Slide } from "react-slideshow-image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import "react-slideshow-image/dist/styles.css";
import "./Metric.css";

const METRICS_PER_VIEW = 3;

/**
 * Horizontal snap carousel for home metrics — always 3 columns visible,
 * swipe advances one metric at a time.
 */
export function MetricsCompactCarousel({ items = [] }) {
  const { t } = useTranslation();
  const list = Array.isArray(items) ? items.filter(Boolean) : [];

  if (!list.length) return null;

  const visible = Math.min(METRICS_PER_VIEW, list.length);
  const canSlide = list.length > visible;

  return (
    <section className="metrics-compact" aria-label={t("metric")}>
      <div className="metrics-container metrics-compact__carousel">
        <Slide
          key={`metrics-${visible}-${list.length}`}
          slidesToScroll={1}
          slidesToShow={visible}
          indicators={canSlide}
          arrows={false}
          autoplay={false}
          infinite={canSlide}
          canSwipe={canSlide}
          cssClass="metrics-compact-slideshow"
        >
          {list.map((item) => (
            <div className="metrics-compact__slide" key={item.key}>
              <div
                className={`metrics-compact__cell metrics-compact__cell--${item.tone || "groups"}`}
              >
                <span className="metrics-compact__icon" aria-hidden="true">
                  <FontAwesomeIcon icon={item.icon} />
                </span>
                <div className="metrics-compact__copy">
                  <p className="metrics-compact__value">{item.value ?? 0}</p>
                  <p className="metrics-compact__label">{item.label}</p>
                </div>
              </div>
            </div>
          ))}
        </Slide>
      </div>
    </section>
  );
}
